// Please note that, this module is included with @theme.liquid to be loaded with the website each time.
// A small check is added to check the link of the page, but the asset it self is downloaded every time
// To find places that might uses this moudule in the feature, please search with "Yassin-Code" across the code base
(function() {
    'use strict';
    const DEBUG = false; // production default
    const TAG = '[Yassin-Code]';
    const log = (...a) => DEBUG && console.log(TAG, ...a);
    const warn = (...a) => DEBUG && console.warn(TAG, ...a); // optional: silence warnings in prod
    const err = (...a) => console.error(TAG, ...a);

    // Marker that script was actually parsed by the browser
    log('script parsed at', new Date().toISOString());

    function isProductUrl() {
        try {
            return /\/products\//i.test(window.location.pathname);
        } catch (_) {
            return false;
        }
    }

    function getProductRoots() {
        // Product page or quickshop can render multiple product wrappers in DOM
        const roots = Array.from(document.querySelectorAll('[data-product-wrapper]'));
        if (roots.length) return roots;
        // If none found, but URL indicates product, return document as fallback root
        if (isProductUrl()) return [document];
        // Quickshop modal check (common class names in Empire)
        const quickshop = document.querySelector('.modal--quickshop-full, .modal--quickshop-slim');
        return quickshop ? [quickshop] : [];
    }

    function getSelectedValue(container) {
        // Gather all option groups
        const groups = Array.from(container.querySelectorAll('[data-variant-option]'));
        const candidates = ['ram', 'memory', 'storage', 'capacity'];

        // Helper: extract the option group name
        const getGroupName = (groupEl) => {
            // Try to find a nearby [data-variant-option-name]
            let nameEl = null;
            let parent = groupEl.parentElement;
            while (parent && !nameEl) {
                const tmp = parent.querySelector && parent.querySelector('[data-variant-option-name]');
                if (tmp) nameEl = tmp;
                parent = parent.parentElement;
            }
            let name = '';
            if (nameEl) {
                name = (nameEl.textContent || nameEl.getAttribute('data-variant-option-name') || '').trim();
            }
            if (!name) {
                const input = groupEl.querySelector('input[name]');
                if (input && input.name) name = input.name.replace(/\+/g, ' ');
            }
            return (name || '').toLowerCase();
        };

        // Helper: get the currently selected value within a specific group
        const getCheckedValueInGroup = (groupEl) => {
            // Prefer the real checked radio value
            const checked = groupEl.querySelector('input[type="radio"]:checked');
            if (checked) return (checked.value || '').trim();

            // Then try a select element
            const sel = groupEl.querySelector('select');
            if (sel && sel.selectedIndex >= 0) {
                const opt = sel.options[sel.selectedIndex];
                if (opt) return (opt.textContent || opt.value || '').trim();
            }

            // Lastly, fall back to the selected class label if present
            const picked = groupEl.querySelector('.options-selection__option-value--selected .options-selection__option-value-name');
            if (picked) return picked.textContent.trim();

            return null;
        };

        // First, try to find a group whose name matches candidate keywords
        let targetGroup = null;
        for (const g of groups) {
            const groupName = getGroupName(g);
            if (candidates.some((c) => groupName.includes(c))) {
                targetGroup = g;
                break;
            }
        }
        if (targetGroup) {
            const val = getCheckedValueInGroup(targetGroup);
            if (val) return val;
        }

        // Next, try any group whose current value text includes a candidate keyword
        for (const g of groups) {
            const val = getCheckedValueInGroup(g);
            if (val && /ram|memory|storage|capacity/i.test(val)) return val;
        }

        // Finally, return the first available selected value
        for (const g of groups) {
            const val = getCheckedValueInGroup(g);
            if (val) return val;
        }

        return null;
    }

    function normalizeMemoryStorageText(value) {
        let v = String(value || '').trim();
        // Turn pipes into slashes for readability
        v = v.replace(/\s*\|\s*/g, ' / ');
        // Collapse extra spaces
        v = v.replace(/\s{2,}/g, ' ');
        return v;
    }

    function updateDynamicTitleAndFeatures(rootEl) {
        try {
            const container = rootEl || document;
            log('update start', container === document ? '(document)' : container);

            const selectedValue = getSelectedValue(container);
            if (!selectedValue) {
                log('no selected value found; skipping update');
                return;
            }
            log('selected value:', selectedValue);

            // Update title suffix with a persistent data marker to avoid duplicate IDs
            const titleEl = container.querySelector('.product-title');
            if (titleEl) {
                let backDoor = titleEl.querySelector('[data-backdoor="true"]');
                if (!backDoor) {
                    backDoor = document.createElement('span');
                    backDoor.setAttribute('data-backdoor', 'true');
                    titleEl.appendChild(backDoor);
                    log('created data-backdoor span');
                }
                const suffix = ` (${selectedValue})`;
                if (backDoor.textContent !== suffix) {
                    backDoor.textContent = suffix; // prefer textContent
                    log('title updated');
                }
            } else {
                log('no .product-title found');
            }
            // Update Key Features item (RAM/Memory/Storage) to mirror the selected option
            const descEl = container.querySelector('[data-product-description]');
            if (descEl) {
                const firstList = descEl.querySelector('ul');
                if (firstList) {
                    const items = Array.from(firstList.querySelectorAll('li'));
                    // Find the item that mentions RAM/Memory/Storage/Capacity
                    const target = items.find((li) => /ram|memory|storage|capacity/i.test(li.textContent));
                    log('key features items:', items.length, 'target found?', !!target);
                    if (target) {
                        const before = (target.textContent || '').trim();
                        const core = normalizeMemoryStorageText(selectedValue);
                        const prefixMatch = before.match(/^\s*(RAM|Memory|Storage|Capacity)\s*[:|-]\s*/i);
                        const newText = prefixMatch ? `${prefixMatch[0]}${core}` : core;

                        if (before !== newText) {
                            target.textContent = newText;
                            log('updated keyfeature (mirror selected option)', {
                                before,
                                after: newText
                            });
                        } else {
                            log('keyfeature unchanged');
                        }
                    } else {
                        log('no matching keyfeature item (RAM/Memory/Storage/Capacity) found; skipping');
                    }

                } else {
                    log('no <ul> under [data-product-description]; skipping keyfeature update');
                }
            } else {
                log('no [data-product-description] found; skipping keyfeature update');
            }
        } catch (e) {
            err('error in updateDynamicTitleAndFeatures:', e);
        }
    }

    // Debounce to avoid excessive updates
    let debouncedTimer = null;
    // Prevent double initialization (e.g., multiple script loads or page cache events)
    let initialized = false;

    function scheduleUpdate(root) {
        if (debouncedTimer) cancelAnimationFrame(debouncedTimer);
        debouncedTimer = requestAnimationFrame(() => {
            const roots = root ? [root] : getProductRoots();
            if (!roots.length) {
                log('no product roots found at schedule; will rely on observers/events');
            }
            roots.forEach(updateDynamicTitleAndFeatures);
        });
    }

    function init() {
        try {
            log('init start at', new Date().toISOString());
            if (initialized) {
                log('init skipped: already initialized');
                return;
            }
            initialized = true;

            // Initial attempt
            scheduleUpdate();

            // React to variant UI changes (delegated)
            document.addEventListener('change', function(e) {
                if (e.target && e.target.closest('[data-variant-option]')) {
                    log('variant UI change detected', e.target);
                    const root = e.target.closest('[data-product-wrapper]') || null;
                    scheduleUpdate(root); // immediate
                    requestAnimationFrame(() => scheduleUpdate(root)); // next frame
                    setTimeout(() => scheduleUpdate(root), 50); // small delay
                }
            });

            // Handle navigation events that may swap content (best-effort)
            window.addEventListener('pageshow', () => {
                log('pageshow');
                scheduleUpdate();
            });
            window.addEventListener('popstate', () => {
                log('popstate');
                scheduleUpdate();
            });

            // Observe DOM for late-inserted product content (e.g., quickshop or dynamic sections)
            const observer = new MutationObserver((mutations) => {
                let found = false;
                for (const m of mutations) {
                    if (m.type === 'childList' && (m.addedNodes && m.addedNodes.length)) {
                        for (const node of m.addedNodes) {
                            if (!(node instanceof Element)) continue;
                            if (node.matches && node.matches('[data-product-wrapper]')) {
                                found = true;
                                scheduleUpdate(node);
                            } else {
                                const nested = node.querySelector && node.querySelector('[data-product-wrapper]');
                                if (nested) {
                                    found = true;
                                    scheduleUpdate(nested);
                                }
                            }
                        }
                    }
                }
                if (found) log('mutation observer: product wrapper detected');
            });

            if (document.body) {
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
                log('mutation observer attached');
            } else {
                warn('document.body not ready; retrying observer soon');
                const i = setInterval(() => {
                    if (document.body) {
                        clearInterval(i);
                        observer.observe(document.body, {
                            childList: true,
                            subtree: true
                        });
                        log('mutation observer attached (retry)');
                    }
                }, 50);
            }

            log('init complete');
        } catch (e) {
            err('init error:', e);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();